import React from 'react';
import { useNavigate } from 'react-router-dom';

// ID del formulario de registro de estudiantes
const FORMULARIO_REGISTRO_ID = "de6750e1-0c28-4c20-9561-9c1492860c41";

const FormularioRegistroPendienteWidget = ({ user }) => {
  const navigate = useNavigate();
  
  // Solo mostrar si el usuario tiene pendiente el formulario
  if (!user?.pendiente_formulario_registro) {
    return null;
  }
  
  // Solo para estudiantes, pastores, graduados
  if (!['estudiante', 'pastor', 'graduado'].includes(user?.rol)) {
    return null;
  }

  const handleClick = () => {
    // Marcar que debe volver al proceso de registro después de llenar el formulario
    localStorage.setItem('volverAProcesoRegistro', 'true');
    navigate(`/app/formulario/${FORMULARIO_REGISTRO_ID}/responder`);
  };

  return (
    <div 
      onClick={handleClick}
      className="relative overflow-hidden bg-gradient-to-r from-red-600 via-orange-500 to-amber-500 rounded-2xl p-5 shadow-2xl cursor-pointer hover:shadow-3xl transition-all duration-300 hover:scale-[1.02] border-4 border-red-700"
      data-testid="formulario-registro-pendiente-widget"
    >
      {/* Efecto de brillo animado */}
      <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full animate-[shimmer_2s_infinite]" 
           style={{animation: 'shimmer 2s infinite', backgroundSize: '200% 100%'}}></div>
      
      {/* Badge de urgencia */}
      <div className="absolute -top-1 -right-1 bg-red-700 text-white text-xs font-bold px-3 py-1 rounded-bl-lg rounded-tr-xl shadow-lg animate-pulse">
        ⚠️ ACCIÓN REQUERIDA
      </div>
      
      <div className="flex items-center gap-4 relative z-10">
        <div className="bg-white/30 backdrop-blur-sm rounded-2xl p-4 shadow-inner">
          <span className="text-4xl">📋</span>
        </div>
        <div className="flex-1">
          <h3 className="text-white font-bold text-xl drop-shadow-lg">
            ¡Tu inscripción está incompleta!
          </h3>
          <p className="text-white/95 text-sm mt-2 leading-relaxed">
            <strong>Completa tu formulario con tus datos personales</strong> para poder inscribirte a las clases del semestre.
          </p>
          <div className="flex items-center gap-2 mt-2 text-yellow-100 text-xs">
            <span>⏱️ Solo 2-3 minutos</span>
            <span>•</span>
            <span>📱 Desde tu celular</span>
          </div>
        </div>
        <div className="bg-white rounded-full p-3 shadow-xl hover:scale-110 transition-transform">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
          </svg>
        </div>
      </div>
      
      <div className="mt-4 bg-white/25 backdrop-blur-sm rounded-xl p-3 text-center relative z-10 border border-white/40">
        <span className="text-white text-base font-bold drop-shadow flex items-center justify-center gap-2">
          <span className="animate-bounce">👆</span>
          TOCA AQUÍ PARA COMPLETAR
          <span className="animate-bounce">👆</span>
        </span>
      </div>
      
      <style jsx>{`
        @keyframes shimmer {
          0% { transform: translateX(-100%); }
          100% { transform: translateX(100%); }
        }
      `}</style>
    </div>
  );
};

export default FormularioRegistroPendienteWidget;
